import { EditedRecord, ReasonPrediction } from '@modules/feedback/store/types';

export const getReasonPredictions = (editRecord?: EditedRecord) => {
  return editRecord?.editPredictions?.filter(
    (editPrediction): editPrediction is ReasonPrediction =>
      editPrediction.type === 'REASON',
  );
};
